import React, { FC } from 'react'
import { Box } from '@ally/metronome-ui'

import { useAccountDetailsContext } from '../../services'
import useCertificateOfDepositSubNav from '../../services/SubNav/useCertificateOfDepositSubNav'
import { CertificateOfDepositDetailsCard } from './CertificateOfDepositDetailsCard'
import TipsAndOpportunities from '../common/TipsAndOpportunities'

export const CertificateOfDepositAccountDetails: FC = () => {
  const { accountDetails } = useAccountDetailsContext()
  /* istanbul ignore next */ // option chaining
  useCertificateOfDepositSubNav(
    accountDetails?.retirementAccountIndicator || false,
  )
  /* istanbul ignore next */ // option chaining
  const accountProductId = accountDetails?.productId

  return (
    <>
      <Box id="cd-details-track">
        {accountProductId && (
          <TipsAndOpportunities productId={accountProductId} />
        )}

        <CertificateOfDepositDetailsCard />
      </Box>
    </>
  )
}
